import actionTypes from '../actionTypes/actionTypes';

export const initialState = {
  isMenuOpen: false,
  isLanguageOpen: false,
  activeLanguage: 0, // 0 = english, 1 = german,
  screenWidth: 0,
  screenHeight: 0,
  windowInnerWidth: 0,
  windowInnerHeight: 0
}

function menuReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.OPEN_MENU:
      return Object.assign({}, state, {
        isMenuOpen: true
      })
      break
    case actionTypes.CLOSE_MENU:
      return Object.assign({}, state, {
        isMenuOpen: false
      })
      break
    case actionTypes.OPEN_LANGUAGE:
      return Object.assign({}, state, {
        isLanguageOpen: true
      })
      break
    case actionTypes.CLOSE_LANGUAGE:
      return Object.assign({}, state, {
        isLanguageOpen: false
      })
      break
    case actionTypes.ACTIVE_LANGUAGE:
      return Object.assign({}, state, {
        activeLanguage: action.data.language
      })
      break
    case actionTypes.SET_SCREEN_WIDTH:
      return Object.assign({}, state, {
        screenWidth: action.data
      })
      break
    case actionTypes.SET_SCREEN_HEIGHT:
      return Object.assign({}, state, {
        screenHeight: action.data
      })
      break
    case actionTypes.SET_INNER_WIDTH:
      return Object.assign({}, state, {
        windowInnerWidth: action.data
      })
      break
    case actionTypes.SET_INNER_HEIGHT:
      return Object.assign({}, state, {
        windowInnerHeight: action.data
      })
      break
    default:
      return state
  }
}

export default menuReducer;